'use strict'

import React      from 'react'
import API        from '../services/api'
import Calculator from '../assets/calculator'
import $          from 'jquery'

export default class YourPreference extends React.Component {
  constructor (props) {
    super(props)

    this.state = {
      packages: [],
      dentalPackage: null
    }

    this.api = new API()

    this.changeValueClick = this.changeValueClick.bind(this)
    this.onValueChange = this.onValueChange.bind(this)
  }

  componentWillMount () {
    const dentalPackage = this.props.summary['dental-package']

    this.api.getPackages().then(packages => {
      this.setState({packages, dentalPackage})
    })
  }

  changePackage (dentalPackage) {
    const { onChange } = this.props

    window.ga('send', 'event', {
      eventCategory: 'Detailed Form',
      eventAction: 'Click',
      eventLabel: 'Plan Choice'
    })

    onChange('dental-package', {
      displayName: 'Package',
      value: `${dentalPackage.name} $${dentalPackage.voucherValue}`,
      weeklyPayment: '$' + dentalPackage.weeklyPayment.toFixed(2),
      fortnightlyPayment: '$' + dentalPackage.fortnightlyPayment.toFixed(2),
      pageRef: 'your-details',
      order: 7,
      displayInSummary: true
    })
  }

  changeValueClick (e) {
    e.preventDefault()
    this.setState({ dentalPackage: null })
  }

  onValueChange () {
    const dentalPackage = this.props.summary['dental-package']
    this.setState({dentalPackage})
  }

  render () {
    const { summary, onChange } = this.props
    const { dentalPackage } = this.state

    const {value, weeklyPayment, weeks, savings} =
      summary['dental-package'] || {
        value: '1000',
        weeklyPayment: '49',
        weeks: '19',
        savings: '0'
      }

    const calculatorPackage = [1000, 2000, 3000, 4000, 5000, 10000].indexOf(Number(value.replace(/[^0-9\.]+/g, '')))
    const calculatorAmount = Number(weeklyPayment.replace(/[^0-9\.]+/g, ''))

    const dentalVoucherText = summary['full-name']
      ? `${summary['full-name'].value.split(' ')[0]}'s Dental Voucher`
      : ''

    const payment = summary['dental-package']
      ? parseInt(summary['dental-package'].weeklyPayment.replace(/[^\d]/, ''))
      : 49

    let minWeeks = 'fifth'

    switch (payment) {
      case 49:  minWeeks = 'fifth';  break
      case 59:  minWeeks = 'fourth'; break
      case 79:  minWeeks = 'third';  break
      case 99:  minWeeks = 'second'; break
      case 150: minWeeks = 'first';  break
    }

    return (
      <section className='your-preference cf'>
        <div className='preference-info'>
          <p>
            Based on your package you can start your dental treatment after your {minWeeks} weekly payment.
          </p>
          <a
            href=''
            onClick={(e) => {
              e.preventDefault()
              $('#edit-calc')[0].click()
            }}>
            Want to start faster?
          </a>
          <i>
            Treatment will be spread across the term of your package as agreed by your dental practitioner.
            Any unused credit is not billed. Super Easy, no waste!
          </i>
        </div>
        <br />
        <h2 className='header'>{dentalVoucherText}</h2>
        <div className='row'>
          {dentalPackage
            ? <table className='package-table'>
              <tbody>
                <tr>
                  <td>Voucher Value</td>
                  <td>
                    {value.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    <br /><a id='edit-calc' href='' onClick={this.changeValueClick}>change</a>
                  </td>
                </tr>
                <tr>
                  <td>Weekly Payment</td>
                  <td>{weeklyPayment}</td>
                </tr>
                <tr>
                  <td>Number of Payments</td>
                  <td>{weeks}</td>
                </tr>
                <tr>
                  <td>Saving</td>
                  <td>{savings}</td>
                </tr>
                <tr>
                  <td>Interest</td>
                  <td>$0 (Always)</td>
                </tr>
              </tbody>
            </table>
            : <Calculator
              onChange={onChange}
              showForm={this.onValueChange}
              hideTitle
              button='save'
              amount={calculatorAmount}
              package={calculatorPackage} />
            }
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/form-segments/your-preference.js